import { CommonModule } from '@angular/common';
import { Component, Injector, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { Payloads } from '../../../../model/payloads.model';
import { FormsModule } from '@angular/forms';
import { ApiService, CustomHttpParams } from 'src/app/services/api.service';

@Component({
  selector: 'app-view-payload',
  standalone: true,
  imports: [RouterModule, CommonModule, FormsModule],
  templateUrl: './view-payload.component.html',
  styleUrl: './view-payload.component.scss'
})
export class ViewPayloadComponent implements OnInit {
  public payload: Payloads = {
    received_type: '',
    received_dttm: '',
    sent_type: '',
    sent_dttm: '',
    request_id: '',
    ven_id: 0,
    id: 0,
    received_body: '',
    sent_body: '',
  };

  public payloadId: any;
  public error: string | null = null;
  public isLoading: boolean = true;

  constructor(
    private injector: Injector,
    private router: Router,
    private payloadService: ApiService
  ) {
    this.router = injector.get(Router);
    this.router.events.subscribe((event: any) => {
      if (event?.snapshot?.params.id) {
        this.payloadId = event.snapshot.params.id;
      }
    });
  }

  ngOnInit(): void {
    if (this.payloadId) {
      const queryParams: CustomHttpParams = {
        'depth': 1,
        'id': this.payloadId,
      };
      this.payloadService.getPayloads(queryParams).subscribe({
        next: (response: any) => {
          if (response && response.length) {
            this.payload = response[0];

            // Format XML if applicable
            if (this.payload.sent_body && this.isXml(this.payload.sent_body)) {
              this.payload.sent_body = this.formatXml(this.payload.sent_body);
            }

            if (this.payload.received_body && this.isXml(this.payload.received_body)) {
              this.payload.received_body = this.formatXml(this.payload.received_body);
            }
          }
          this.isLoading = false;
        },
        error: (err) => {
          console.error(err);
          this.error = typeof err === 'string' ? err : 'Failed to load payload data';
          this.isLoading = false;
        }
      });
    } else {
      this.error = 'No payload ID provided';
      this.isLoading = false;
    }
  }

  // Helper method to check if content is XML
  private isXml(text: string): boolean {
    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, 'text/xml');
      return !doc.querySelector('parsererror');
    } catch (e) {
      return false;
    }
  }

  // Helper method to format XML
  private formatXml(xml: string): string {
    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(xml, 'text/xml');
      const serializer = new XMLSerializer();
      const formatted = serializer.serializeToString(doc)
        .replace(/></g, '>\n<')
        .replace(/><\/(\w+)>/g, '>\n</\$1>')
        .replace(/<(\w+)([^>]*)>/g, '<\$1\$2>\n')
        .replace(/\n{2,}/g, '\n');

      return formatted;
    } catch (e) {
      return xml;
    }
  }

  back() {
    this.router.navigate(['/payloads']);
  }
}
